import React from 'react';
import AuthButton from './AuthButton';
import './SplashPage.css';

interface SplashPageProps {
  onPlayAsGuest: () => void;
  user: { name: string; avatar_url: string | null } | null;
  isLoading: boolean;
  onSignIn: (idToken: string) => Promise<any>;
  onSignOut: () => void;
}

const SplashPage: React.FC<SplashPageProps> = ({ onPlayAsGuest, user, isLoading, onSignIn, onSignOut }) => {

  return (
    <div className="splash-container">
      <div className="splash-content">
        <img src="/snap_pairs_tile.png" alt="Snap Pairs Logo" className="splash-logo" />
        <h1 className="splash-title">Snap Pairs</h1>
        <p className="splash-tagline">One-Minute Mahjong Puzzle</p>

        <div className="splash-auth">
          <AuthButton
            user={user}
            isLoading={isLoading}
            onSignIn={onSignIn}
            onSignOut={onSignOut}
          />
        </div>

        <p className="splash-description">
          Sign in to track your scores and compete on the leaderboard!
        </p>

        <button className="play-as-guest-btn" onClick={onPlayAsGuest}>
          Play as Guest
        </button>
        <p className="guest-note">You can play without signing in, but scores won't be saved</p>
      </div>
    </div>
  );
};

export default SplashPage;
